export const isLatLngObject = (coordinate: any): coordinate is { lat: number; lng: number } => {
  return (
    typeof coordinate === 'object' &&
    'lat' in coordinate &&
    'lng' in coordinate &&
    typeof coordinate.lat === 'number' &&
    typeof coordinate.lng === 'number'
  );
};
